var React = require('react');

function Fb (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"32","height":"32","rx":"6","fill":"#4367B2","key":0}),React.createElement("path",{"d":"M27 6.46429V24.5357C27 25.8962 25.8962 27 24.5357 27H20.1565V17.9027H23.2676L23.7143 14.4321H20.1565V12.2143C20.1565 11.208 20.4337 10.5252 21.8763 10.5252H23.7143V7.42433C23.396 7.38326 22.3076 7.28571 21.0344 7.28571C18.3853 7.28571 16.5679 8.9029 16.5679 11.8754V14.4373H13.4464V17.9078H16.573V27H6.46429C5.10379 27 4 25.8962 4 24.5357V6.46429C4 5.10379 5.10379 4 6.46429 4H24.5357C25.8962 4 27 5.10379 27 6.46429Z","fill":"white","key":1})]);
}

Fb.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Fb;

Fb.default = Fb;
